/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementListPrevResponse } from './EventSceneManagementListPrevResponse';

export type EventSceneManagementListPrevResponseApiRespoonse = {
    data?: EventSceneManagementListPrevResponse;
    status?: EventSceneManagementListPrevResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementListPrevResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

